import * as React from 'react';

export interface IIconProps {
    size?: string;
    icon: string;
    onClick?: () => void;
}

export class Icon extends React.PureComponent<IIconProps, {}> {
    constructor(props: IIconProps) {
        super(props);
    }

    public render() {
        return <i onClick={this.props.onClick} className={`fas fa-${this.props.size} fa-${this.props.icon}`}/>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Icon.tsx